import { LoadableFactory } from '®shared/data';
import { ReadingListDetails } from '®shared/reading-list/models';

import {
  ListResolverStoreActionTypes,
  ListResolverStoreActions,
} from './list-resolver-store.actions';
import { ListResolverStoreState } from './list-resolver-store.state';

export function listResolverStoreReducer(
  state: ListResolverStoreState,
  action: ListResolverStoreActions,
): ListResolverStoreState {
  switch (action.type) {
    case ListResolverStoreActionTypes.CLEAR_DRAFT_AND_PUBLISHED: {
      const { listId } = action.payload;
      return {
        ...state,
        draftListsById: state.draftListsById.delete(listId),
        publishedListsById: state.publishedListsById.delete(listId),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_REQUESTED: {
      return {
        ...state,
        draftListsById: state.draftListsById.set(
          action.payload.listId,
          LoadableFactory.loading(),
        ),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_LOADED: {
      const { listId, list } = action.payload;
      return {
        ...state,
        draftListsById: state.draftListsById.set(
          listId,
          LoadableFactory.loaded(list),
        ),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_LOADING_FAILED: {
      const { listId, error } = action.payload;
      return {
        ...state,
        draftListsById: state.draftListsById.set(
          listId,
          LoadableFactory.errored<ReadingListDetails>(error),
        ),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_REQUESTED: {
      return {
        ...state,
        publishedListsById: state.publishedListsById.set(
          action.payload.listId,
          LoadableFactory.loading(),
        ),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_LOADED: {
      const { listId, list } = action.payload;
      return {
        ...state,
        publishedListsById: state.publishedListsById.set(
          listId,
          LoadableFactory.loaded(list),
        ),
      };
    }
    case ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_LOADING_FAILED: {
      const { listId, error } = action.payload;
      return {
        ...state,
        publishedListsById: state.publishedListsById.set(
          listId,
          LoadableFactory.errored<ReadingListDetails>(error),
        ),
      };
    }
    case ListResolverStoreActionTypes.CLEAR_ALL_LISTS: {
      return {
        ...state,
        draftListsById: state.draftListsById.clear(),
        publishedListsById: state.publishedListsById.clear(),
      };
    }
  }

  return state;
}
